import { chains as gearboxSdkChains } from "@gearbox-protocol/sdk";
import { Chain, defineChain } from "viem";
import { ink } from "viem/chains";

export const chains: Record<string, Chain> = {
  mainnet: gearboxSdkChains.Mainnet,
  base: gearboxSdkChains.Base,
  megaethTestnet: gearboxSdkChains.MegaETH,
  avalanche: gearboxSdkChains.Avalanche,
  monadTestnet: gearboxSdkChains.Monad,
  bsc: gearboxSdkChains.BNB,
  worldchain: gearboxSdkChains.WorldChain,
  etherlink: gearboxSdkChains.Etherlink,
  optimism: gearboxSdkChains.Optimism,
  arbitrum: gearboxSdkChains.Arbitrum,
  sonic: gearboxSdkChains.Sonic,
  berachain: gearboxSdkChains.Berachain,
  lisk: gearboxSdkChains.Lisk,
  hemi: gearboxSdkChains.Hemi,
  plasma: gearboxSdkChains.Plasma,
  ink: ink,
  monad: defineChain({
    id: 143,
    name: "Monad",
    nativeCurrency: {
      name: "Monad",
      symbol: "MON",
      decimals: 18,
    },
    rpcUrls: {
      default: {
        http: [
          "https://permissionless-staging.gearbox.foundation/api/proxy/rpc/143",
        ],
      },
    },
    blockExplorers: {
      default: {
        name: "Monad Explorer",
        url: "https://explorer.monad.xyz",
      },
    },
    contracts: {
      multicall3: {
        address: "0xcA11bde05977b3631167028862bE2a173976CA11",
        blockCreated: 9248132,
      },
    },
    testnet: false,
  }),
  somnia: defineChain({
    id: 5031,
    name: "Somnia",
    nativeCurrency: {
      name: "Somnia",
      symbol: "STT",
      decimals: 18,
    },
    rpcUrls: {
      default: {
        http: ["https://api.infra.mainnet.somnia.network"],
      },
    },
    blockExplorers: {
      default: {
        name: "Somnia Explorer",
        url: "https://explorer.somnia.network",
      },
    },
    contracts: {
      multicall3: {
        address: "0x0Fcd764b37F269A91D3e602B440eFcb12F5C19b9",
        blockCreated: 38516341,
      },
    },
    testnet: false,
  }),
};

export const chainMap: Record<number, Chain> = Object.values(chains).reduce(
  (acc, chain) => {
    acc[chain.id] = chain;
    return acc;
  },
  {} as Record<number, Chain>,
);

export const SDK_GAS_LIMIT_BY_CHAIN_ID: Record<number, bigint> = {
  [chains.monad.id]: 100_000_000n,
};
